// filepath: src/components/inventory/InventoryGrid.js
import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';
import { MdEdit } from "react-icons/md";
import { Check, Plus, ShoppingBag } from "lucide-react";
import { resolveAssetUrl } from "../../../utils/assetUrl";

const resolveProductImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    const value = String(imageUrl);
    if (value.startsWith("data:") || value.startsWith("blob:") || /^(?:[a-z]+:)?\/\//i.test(value)) {
        return resolveAssetUrl(value);
    }
    return resolveAssetUrl(`/uploads/${value.replace(/^\/?uploads\//, "")}`);
};


const InventoryGrid = ({ inventories, onAdjust, onEdit, selectedBranchId = "", selectedRestockIds = new Set(), onToggleRestock }) => (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {inventories.map(inv => {
            const isInRestockList = selectedRestockIds.has(String(inv.id));
            return (
            <div key={inv.id}>
                <ProductCard
                    product={{
                        id: inv.id,
                        name: inv.product_name,
                        image: resolveProductImageUrl(inv.image_url),
                        stock: selectedBranchId ? (inv.released_quantity ?? 0) : inv.quantity,
                        description: inv.description || inv.product_description || '',
                        price: typeof inv.price === 'number' && inv.price > 0 ? inv.price : '',
                    }}
                    showAddToCart={false}
                    showEdit={false}
                    onIncrease={e => { if (e) e.stopPropagation(); onAdjust(inv.id, +1); }}
                    onDecrease={e => { if (e) e.stopPropagation(); onAdjust(inv.id, -1); }}
                    mode="inventory"
                    disableIncrease={Boolean(selectedBranchId) && (Number(inv.quantity) || 0) <= 0}
                >
                    <div className="mt-2 flex items-center justify-center gap-2">
                        <button
                            type="button"
                            onClick={(event) => {
                                event.stopPropagation();
                                onToggleRestock?.(inv);
                            }}
                            className={`flex h-8 w-8 cursor-pointer items-center justify-center rounded-xl border shadow-sm transition hover:scale-[1.03] ${
                                isInRestockList
                                    ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                                    : "border-slate-200 bg-white text-slate-600"
                            }`}
                            title={isInRestockList ? "Remove from to-buy list" : "Add to to-buy list"}
                            aria-pressed={isInRestockList}
                            aria-label={`${isInRestockList ? "Remove" : "Add"} ${inv.product_name} ${isInRestockList ? "from" : "to"} to-buy list`}
                        >
                            {isInRestockList ? <Check size={14} /> : <Plus size={14} />}
                            <ShoppingBag size={13} className="-ml-1" />
                        </button>
                        <button
                            type="button"
                            onClick={onEdit ? () => onEdit(inv) : undefined}
                            className="cursor-pointer w-8 h-8 rounded-xl flex items-center justify-center shadow-sm transition hover:scale-[1.03]"
                            style={{
                                background: 'linear-gradient(135deg, var(--color-primary), color-mix(in srgb, var(--color-primary) 78%, black))',
                                color: 'var(--color-text, #fff)',
                            }}
                            title="Edit"
                        >
                            <MdEdit size={14} color="#fff" />
                        </button>
                    </div>
                </ProductCard>
            </div>
            );
        })}
    </div>
);

export default InventoryGrid;
